(function () {
  document.querySelectorAll('[data-product-tabs]').forEach(function (root) {
    var tabs   = root.querySelectorAll('[data-tab-trigger]');
    var panels = root.querySelectorAll('[data-tab-panel]');

    function activate(id, opts) {
      var updateHash = opts && opts.updateHash === false ? false : true;
      tabs.forEach(function (t) {
        var on = t.dataset.tabTrigger === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.dataset.tabPanel === id;
        p.classList.toggle('is-active', on);
        if (on) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
      if (updateHash) {
        history.replaceState(null, '', '#tab=' + id);
      }
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { activate(t.dataset.tabTrigger); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var arr  = Array.prototype.slice.call(tabs);
          var idx  = arr.indexOf(t);
          var next = arr[(idx + (e.key === 'ArrowRight' ? 1 : -1) + arr.length) % arr.length];
          next.focus();
          activate(next.dataset.tabTrigger);
        }
      });
    });

    var match = location.hash.match(/tab=(desc|spec)/);
    if (match) activate(match[1], { updateHash: false });
  });
})();
